export const ROW_SIZE = 42
export const ROW_PLACEHOLDER_OFFSET = 3

export const DEFAULT_DELETE_MODAL_TEXTS = Object.freeze({
    itemLabel: 'template',
    title: 'Delete Template',
    confirmLabel: 'Delete',
    cancelLabel: 'Cancel',
})

export const DELETE_MODE = Object.freeze({
    SINGLE: 'single',
    BULK: 'bulk',
})
